export default "__VITE_ASSET__e14574a1__"